/**
 * City-aware neighborhood chips for the wizard neighborhood step.
 * Keyed by city slug (lowercase, matching SlotState.city from orchestrator).
 */
export type NeighborhoodChip = { label: string; slug: string };

export const CITY_NEIGHBORHOODS: Record<string, NeighborhoodChip[]> = {
  barcelona: [
    { label: 'Gràcia', slug: 'gracia' },
    { label: 'Eixample', slug: 'eixample' },
    { label: 'El Born', slug: 'el-born' },
    { label: 'Sants', slug: 'sants' },
    { label: 'Poblenou', slug: 'poblenou' },
  ],
  madrid: [
    { label: 'Malasaña', slug: 'malasana' },
    { label: 'Chamberí', slug: 'chamberi' },
    { label: 'Salamanca', slug: 'salamanca' },
    { label: 'Chamartín', slug: 'chamartin' },
    { label: 'Lavapiés', slug: 'lavapies' },
  ],
  valencia: [
    { label: 'Ruzafa', slug: 'ruzafa' },
    { label: 'El Carmen', slug: 'el-carmen' },
    { label: 'Benimaclet', slug: 'benimaclet' },
    { label: 'Eixample', slug: 'eixample-valencia' },
  ],
  sevilla: [
    { label: 'Triana', slug: 'triana' },
    { label: 'Nervión', slug: 'nervion' },
    { label: 'Alameda', slug: 'alameda' },
    { label: 'Santa Cruz', slug: 'santa-cruz' },
  ],
  malaga: [
    { label: 'Centro', slug: 'centro' },
    { label: 'El Soho', slug: 'el-soho' },
    { label: 'La Malagueta', slug: 'la-malagueta' },
  ],
  bilbao: [
    { label: 'Casco Viejo', slug: 'casco-viejo' },
    { label: 'Indautxu', slug: 'indautxu' },
    { label: 'Abando', slug: 'abando' },
  ],
  zaragoza: [
    { label: 'Centro', slug: 'centro-zaragoza' },
    { label: 'Delicias', slug: 'delicias' },
    { label: 'Universidad', slug: 'universidad-zaragoza' },
  ],
};

/**
 * Returns the neighborhood chips for a city slug.
 * Returns [] for unknown cities — caller shows only the autocomplete.
 */
export function getNeighborhoodsForCity(citySlug: string): NeighborhoodChip[] {
  return CITY_NEIGHBORHOODS[citySlug] ?? [];
}
